import "./liveChat.scss";
const LiveChat = ({ roomId }) => {
  return <livelike-chat roomid={roomId} timestamps showavatar></livelike-chat>;
};
export default LiveChat;
